import { useEffect } from "react";
import { tellAppReady } from "../lib/inApp";
import { BrandGlyph } from "./BrandMark";
import { FlashsuiteMenu, useFlashsuiteScript } from "./FlashsuiteMenu";

/**
 * Inside the Flashsuite phone app, a business with no Flashroom plan sees this one sentence and nothing
 * that sells or points to where to buy (Apple 3.1.3(f), flashsuite-phone docs/APP-MODE.md section 2).
 * The Flashsuite menu stays, so the person can switch business or sign out.
 */
export function NotOnYet({ business }: { business: string }) {
  useFlashsuiteScript();
  useEffect(tellAppReady, []);
  return (
    <div className="authroot notonyet">
      <div className="notonyet-menu">
        <FlashsuiteMenu compact />
      </div>
      <BrandGlyph size={44} />
      <p>Flashroom is not on for {business} yet.</p>
    </div>
  );
}
